/**
 * Exposed CSS variables
 *
 * @prop --visual-picker-gap: The gap between visual picker items default is 0.5rem
 *
 * @prop --visual-picker-item-padding: The padding of the visual picker item default is `1.25rem`
 * @prop --visual-picker-item-radius: The border radius of the visual picker item default is `0.35rem`
 * @prop --visual-picker-item-border-width: The border width of the visual picker item default is `0.125rem`
 * @prop --visual-picker-item-border-color: The border color of the visual picker item default is `--amalitech-color-neutral-300`
 * @prop --visual-picker-bg: The background color of the visual picker item default is `amalitech-color-light` 
 * @prop --visual-picker-transition-duration: The transition duration of the visual picker item default is `0.3s`
 * @prop --visual-picker-transition-timing: The transition timing of the visual picker item default is `ease`
 * @prop --visual-picker-active-border-width: The border width of the visual picker item when active default is `0.125rem`
 * @prop --visual-picker-active-box-shadow: The box shadow of the visual picker item when active default is `0 4px 4px 0 rgba(0, 0, 0, 0.16)`
 * @prop --visual-picker-active-color: The color of the visual picker item when active default is `amalitech-color-primary`
 * @prop --visual-picker-checked-icon: The icon of the visual picker item when checked default is a checkmark svg
 * @prop --visual-picker-label-color: The color of the visual picker item label default is `amalitech-color-neutral-700`
 * @prop --visual-picker-font-size: The font size of the visual picker item label default is `1rem`
 * @prop --visual-picker-font-weight: The font weight of the visual picker item label default is `500`
 * @prop --visual-picker-font-family: The font family of the visual picker item label default is `amalitech-base-font-family`
 */

:host {
  display: flex;
  gap: var(--visual-picker-gap, 0.5rem);
}

:host(.align-horizontal) {
  flex-direction: row;
}

:host(.align-vertical) {
  flex-direction: column;
}
